import React from "react";

const spinnerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  background: "var(--bg, #ffffff)",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  gap: 24,
};

const pulseStyle = {
  width: 56,
  height: 56,
  borderRadius: 16,
  background: "linear-gradient(135deg, #6d28d9, #7c3aed)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  animation: "loadingPulse 1.4s ease-in-out infinite",
  boxShadow: "0 8px 32px rgba(124, 58, 237, 0.25)",
};

const keyframes = `
@keyframes loadingPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.08); opacity: 0.85; }
}
@keyframes loadingDots {
  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
  40% { opacity: 1; transform: scale(1); }
}
`;

export default function LoadingScreen({ message = "Loading MediSure..." }) {
  return (
    <>
      <style>{keyframes}</style>
      <div style={spinnerStyle}>
        <div style={pulseStyle}>
          <i
            className="fa-solid fa-shield-halved"
            style={{ color: "#fff", fontSize: "1.5rem" }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              margin: "0 0 8px",
              fontSize: "1rem",
              fontWeight: 600,
              color: "var(--text, #1f2937)",
              letterSpacing: "-0.01em",
            }}
          >
            {message}
          </p>
          <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: "var(--brand-500, #7c3aed)",
                  animation: `loadingDots 1.2s ease-in-out ${i * 0.2}s infinite`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
